import { createRouter, createWebHashHistory } from 'vue-router'
import dashboardRoutes from './modules/dashboard'
import taskRoutes from './modules/task'
import customerRoutes from './modules/customer'
import sessionRoutes from './modules/session'
import leadRoutes from './modules/lead'
import creditRoutes from './modules/credit'
import statisticsRoutes from './modules/statistics'
import productRoutes from './modules/product'
import systemRoutes from './modules/system'
import aiBrainRoutes from './modules/aiBrain'
import settingsRoutes from './modules/settings'
import warehouseRoutes from './modules/warehouse'
import configRoutes from './modules/config'
import marketingPlanRoutes from './modules/marketingPlan'
import marketingTargetRoutes from './modules/marketingTargets'
import marketingPkRoutes from './modules/marketingPk'
import msgNoticeSetRoutes from './modules/msgNoticeSet'
import wechatRiskRoutes from './modules/wechatRisk'
import orderRoutes from './modules/order'
import shippingRoutes from './modules/shipping'
import financeRoutes from './modules/finance'
import { setupRouterMonitoring } from './monitoring'

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/Login.vue'),
      meta: { requiresAuth: false },
    },
    {
      path: '/',
      redirect: '/dashboard',
    },
    {
      path: '/',
      component: () => import('@/layouts/MainLayout.vue'),
      meta: { requiresAuth: true },
      children: [
        {
          path: 'reports/:id?',
          name: 'CustomReports',
          component: () => import('@/pages/reports/index.vue'),
          meta: { title: '自定义报表', requiresAuth: true },
        },
        ...dashboardRoutes,
        ...taskRoutes,
        ...customerRoutes,
        ...sessionRoutes,
        ...leadRoutes,
        ...creditRoutes,
        ...statisticsRoutes,
        ...productRoutes,
        ...shippingRoutes,
        ...financeRoutes,
        ...aiBrainRoutes,
        ...warehouseRoutes,
        ...orderRoutes,
        ...systemRoutes,
        ...settingsRoutes,
        ...configRoutes,
        ...marketingPlanRoutes,
        ...marketingTargetRoutes,
        ...marketingPkRoutes,
        ...msgNoticeSetRoutes,
        ...wechatRiskRoutes,
      ],
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'NotFound',
      component: () => import('@/views/NotFound.vue'),
      meta: { title: '页面不存在', requiresAuth: true },
    },
  ],
})

/** 先注册诊断钩子，保留权限守卫重定向前的原始导航证据。 */
setupRouterMonitoring(router)

/** 路由守卫（独立文件管理） */
import { setupRouterGuards } from './guards'
setupRouterGuards(router)

export default router
